/**
 * Client-side work-queue access. Unknown hire/workspace must stay "loading",
 * never flash ไม่มีสิทธิ์ — own shops are in `workspaces` before hire orders arrive.
 */

export function workspaceIdInList(
  workspaceId: string | null | undefined,
  workspaces: Array<{ id: string }>,
): boolean {
  const id = workspaceId?.trim() ?? "";
  if (!id) return false;
  return workspaces.some((workspace) => workspace.id.trim() === id);
}

/**
 * Logged-in viewer on a shop that is not theirs and not hired.
 * Empty / other-shop order cache is unknown, not unhired.
 * A workspace in the viewer's shop list is never an outsider.
 */
export function isLoggedInQueueOutsider(args: {
  workMode: boolean;
  hireStatusKnown: boolean;
  hasViewer: boolean;
  hired: boolean;
  harnessNoAuth: boolean;
  isLoadingWorkspaces: boolean;
  workspaceId: string | null | undefined;
  workspaces: Array<{ id: string }>;
}): boolean {
  if (!args.workMode || !args.hireStatusKnown || !args.hasViewer) return false;
  if (args.hired || args.harnessNoAuth) return false;
  if (args.isLoadingWorkspaces) return false;
  if (!args.workspaces.length) return false;
  return !workspaceIdInList(args.workspaceId, args.workspaces);
}

/**
 * No session at all. A token that has not decoded yet is not a guest —
 * keep preparing so JWT hydration cannot flash ไม่มีสิทธิ์.
 */
export function isGuestQueueNoSession(args: {
  workMode: boolean;
  hireStatusKnown: boolean;
  hasViewer: boolean;
  hasSessionHint: boolean;
}): boolean {
  return Boolean(
    args.workMode &&
      args.hireStatusKnown &&
      !args.hasViewer &&
      !args.hasSessionHint,
  );
}
